'use client';

import React, { useEffect } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import SectionNavbar from './home/component/SectionNavbar';
import CustomButton from './home/component/CustomButton';
import AOS from 'aos';
import 'aos/dist/aos.css';

/**
 * NotFound Component
 * Custom 404 page for Pekalen Rafting
 */
const NotFound: React.FC = () => {
  const pattern = "/image/pattern.webp";

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out',
    });
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      {/* Navbar */}
      <SectionNavbar />

      {/* Main Content */}
      <div className="relative flex-1 w-full overflow-hidden bg-linear-to-r from-[#EEDA44] to-[#FFE83D]">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-2">
          <Image
            src={pattern}
            alt="background pattern"
            fill
            className="object-cover"
            priority
            quality={30}
            sizes="100vw"
          />
        </div>

        {/* Content Container */}
        <div className="relative z-10 h-full flex items-center justify-center px-6 py-16">
          <div className="max-w-3xl w-full text-center flex flex-col items-center gap-8">
            {/* 404 Illustration */}
            <div data-aos="fade-up" className="flex items-center justify-center">
              <div className="relative">
                <h1 className="banner-text font-bold lg:text-[180px] md:text-[140px] text-[100px] text-[#222222] m-0 leading-none">
                  404
                </h1>
              </div>
            </div>

            {/* Title */}
            <div data-aos="fade-up" data-aos-delay="100">
              <h2 className="font-bold lg:text-[48px] md:text-[36px] text-[28px] text-[#222222] m-0 mb-4">
                Halaman Tidak Ditemukan
              </h2>
            </div>

            {/* Description */}
            <div data-aos="fade-up" data-aos-delay="200">
              <p className="font-family-open-sans font-normal lg:text-[18px] md:text-[16px] text-[14px] text-[#222222] leading-relaxed max-w-xl mx-auto mb-0">
                Maaf, halaman yang Anda cari tidak dapat ditemukan. Mungkin halaman tersebut telah dipindahkan atau tidak pernah ada.
                Yuk kembali ke beranda dan mulai petualangan rafting Anda!
              </p>
            </div>

            {/* CTA Button */}
            <div data-aos="fade-up" data-aos-delay="300" className="mt-4">
              <Link href="/">
                <CustomButton text="Kembali ke Beranda" />
              </Link>
            </div>

            {/* Additional Help Text */}
            <div data-aos="fade-up" data-aos-delay="400" className="mt-8">
              <p className="font-family-open-sans font-normal text-[14px] text-[#222222]/80">
                Butuh bantuan? Hubungi kami di{' '}
                <a
                  href="https://wa.me/6285134567402"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-bold underline hover:text-[#222222]"
                >
                  WhatsApp
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
